const TRACKING_PARAMS = new Set([
  'gclid',
  'fbclid',
  'msclkid',
  'ttclid',
  'yclid',
]);

function shouldForwardParam(key: string): boolean {
  if (TRACKING_PARAMS.has(key)) return true;
  return key.toLowerCase().startsWith('utm_');
}

export function buildSuccessRedirectUrl(
  pathname: string,
  params?: Record<string, string | number | boolean | null | undefined>,
): string {
  const url = new URL(pathname, window.location.origin);
  const currentParams = new URLSearchParams(window.location.search);

  currentParams.forEach((value, key) => {
    if (shouldForwardParam(key) && !url.searchParams.has(key)) {
      url.searchParams.set(key, value);
    }
  });

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') return;
      url.searchParams.set(key, String(value));
    });
  }

  return url.toString();
}

export function redirectToSuccessPage(
  pathname: string,
  params?: Record<string, string | number | boolean | null | undefined>,
) {
  window.location.assign(buildSuccessRedirectUrl(pathname, params));
}
